import { inject } from 'vue';
import { inBlockEditorKey } from '#layers/block-engine/utils/block/const';

/**
 * Check if current block is rendered in block editor.
 */
export function useBlockInEditor() {
	return inject(inBlockEditorKey, false);
}
